import {Component} from '@angular/core'

@Component({
    selector: 'foa-about',
    imports: [],
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss'
})
export class AboutComponent {

}
